import React from 'react';
import { Outlet } from 'react-router-dom';

import { useOrganizationSelector } from '../../hooks/useOrganizationSelector';

export const ApplicationFlowContainer = () => {
  useOrganizationSelector();

  return <Outlet />;
};
